export enum MoleType {
    BLUE = 'blue',  // BAD mole - we want to catch and freeze these
    RED = 'red'     // GOOD mole - we don't want to catch these
}

export enum MoleState {
    HIDDEN = 'hidden',      // Mole is below ground
    POPPING = 'popping',    // Mole is coming up (was RISING)
    VISIBLE = 'visible',    // Mole is fully visible and can be hit
    FROZEN = 'frozen',      // Blue mole caught and frozen (hole locked)
    GONE = 'gone'           // Red mole caught and removed
}

export interface MoleData {
    id: string; // Unique identifier (e.g., "BlueMole01", "RedMole03")
    holeIndex: number;
    type: MoleType;
    state: MoleState;
    sprite?: Phaser.GameObjects.Sprite | Phaser.GameObjects.Image | Phaser.GameObjects.Arc;
    eyeGraphics?: Phaser.GameObjects.Arc[]; // Store eye graphics for cleanup
    physicsBody?: Phaser.Physics.Arcade.Body; // Physics body for collision detection
    hatGraphics?: Phaser.GameObjects.GameObject[]; // Hat graphics when frozen (mole wears the hat)
    riseTimer?: Phaser.Time.TimerEvent;
    visibleTimer?: Phaser.Time.TimerEvent;
    fallTimer?: Phaser.Time.TimerEvent;
    isFrozen?: boolean; // Whether mole is frozen by hat
}

